import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import { flushSync } from "react-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTrigger } from "@clarkinc/zest-design-system/ui";
import { Image } from "@wss/image";
interface WarningIconProps {
  style?: React.CSSProperties;
}
interface Prop65WarningProps {
  prop65Disclaimer?: string;
}
const WarningIcon = ({
  style
}: WarningIconProps) => <Image alt="" className="details-disclaimer-icon h-5 -mb-0.5 mr-1 w-5" src="/uploads/design/2018/7/prop-65-warning-icon.png" style={style} height={40} width={40} data-sentry-element="Image" data-sentry-component="WarningIcon" data-sentry-source-file="Prop65Warning.tsx" />;
const WarningContent = ({
  prop65Disclaimer
}: Prop65WarningProps) => {
  return <div style={{
    backgroundColor: "#fff",
    border: "2px solid",
    borderRadius: "8px",
    color: "#000",
    fontFamily: "sans-serif",
    fontSize: "18px",
    margin: "0 auto",
    maxWidth: "100%",
    padding: "10px",
    textAlign: "left",
    width: "430px"
  }} data-sentry-component="WarningContent" data-sentry-source-file="Prop65Warning.tsx">
      <WarningIcon style={{
      height: "19px",
      marginBottom: "-2px",
      marginRight: "4px",
      width: "19px"
    }} data-sentry-element="WarningIcon" data-sentry-source-file="Prop65Warning.tsx" />
      <span style={{
      fontWeight: "700",
      marginRight: "4px"
    }}>
        WARNING:
      </span>
      <span dangerouslySetInnerHTML={{
      __html: prop65Disclaimer ?? ""
    }} />
    </div>;
};
const Prop65Warning = ({
  prop65Disclaimer
}: Prop65WarningProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  function handleOpen() {
    setIsOpen(true);
  }
  const handleClickPrint = (): void => {
    const printWindow = window.open("", "_blank", "width=600,height=600");
    if (!printWindow) return;
    printWindow.document.title = "Prop65 Warning";
    const root = createRoot(printWindow.document.body);
    flushSync(() => root.render(<WarningContent prop65Disclaimer={prop65Disclaimer} />));
    printWindow.print();
  };
  return <>
      <ModalTrigger className="bg-transparent font-bold text-base leading-6 p-0 text-green-500 active:text-green-800 active:underline hover:text-green-700 hover:underline" type="button" theme="headless" onClick={handleOpen} data-sentry-element="ModalTrigger" data-sentry-source-file="Prop65Warning.tsx">
        Prop 65 Warning
      </ModalTrigger>
      <Modal aria-label="Prop 65 Warning" id="prop65-warning-modal" theme="wss" open={isOpen} onOpenChange={setIsOpen} data-sentry-element="Modal" data-sentry-source-file="Prop65Warning.tsx">
        <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="Prop65Warning.tsx">Attention CA Residents</ModalHeader>
        <ModalBody data-sentry-element="ModalBody" data-sentry-source-file="Prop65Warning.tsx">
          <p className="leading-6 mb-0 text-left text-lg">
            <WarningIcon data-sentry-element="WarningIcon" data-sentry-source-file="Prop65Warning.tsx" />
            <span className="font-bold mr-1">WARNING:</span>
            <span className="setProp65" dangerouslySetInnerHTML={{
            __html: prop65Disclaimer ?? ""
          }} />
          </p>
        </ModalBody>
        <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="Prop65Warning.tsx">
          <Button color="green" size="large" className="font-semibold font-[revert]" onClick={handleClickPrint} data-sentry-element="Button" data-sentry-source-file="Prop65Warning.tsx">
            Print this Message
          </Button>
        </ModalFooter>
      </Modal>
    </>;
};
export default Prop65Warning;